<template lang="pug">
validation-observer.analise(ref='validation' tag='div')
  div.analise(v-if="despachoAtual !== null")
    app-analise-header(
      :id-processo="despachoAtual.processo.id",
      :idProcesso="isValidacao ? parseInt(idProcesso) : false",
      v-if="despachoAtual.processo !== null"
      :numero-processo="despachoAtual.processo.numeroProcesso",
      :statusProcesso="despachoAtual.processo.status",
      titulo-analise="Emissão de título"
      :tipo="typeof despachoAtual.processo.tipo === 'object' ? despachoAtual.processo.tipo.codigo : despachoAtual.processo.tipo"
      :numeroProtocolo="despachoAtual.processo.numeroProtocolo"
      :show-separate="true"
      :show-messages='true'
      :opcoesHeader="true"
      :btnSolicitarInformacao="true"
      :idDespacho="despachoAtual.id"
    )
      template(slot="separate")
        el-card(shadow="hover").card-collapse
          app-despachos(
            :idProcesso="idProcesso",
            :data="dadosCadastro",
            @getDownload="getDownload",
          )
      template(slot="analise")
        el-steps.extra-margin-top-bottom(:active='active', finish-status='success', simple)
          el-step(title='Confirmar dados')

        app-pdf-slider(
          v-if="bytes"
          :documentosBytes="arrayBytes"
          :primeiroDocumento="primeiroDocumento"
          @changePdfDownload="changePdfDownload"
          )

        div(v-if="isRevisao")
          validation-provider(rules="required", v-slot="{ errors }")
            app-label.input-text-editor(label="Despacho")
            app-editor-texto.input(
              @onTextChange="onTextChange",
              v-model="despachoAtual.textoDespacho",
              :class="{'erro' : errors.length}"
              ref="editorTexto"
            )
            span.help.erro {{ errors[0] }}

          app-anexo(
            :id="'upload-anexo-despacho'",
            @uploadFile="uploadFile",
            :files="despachoAtual.documentos",
            @removeFile="removeFile"
            @downloadDocumentoCadastro="downloadDocumentoCadastro",
            :tipoExibir="'ANEXO_ANALISE'"
          )

        div.extra-margin-top(v-if="acoesRadio.length > 0 && !isReurb && !isCertidao")
          validation-observer.flex-around(ref='validationTitulo' tag='div')
            app-radios-tramitacao(
              :radios="acoesRadio",
              :isDecisao="isDecisao",
              @changeRadio="changeRadio",
              :radioInicial="despachoAtual.acao",
            )

        div.flex.extra-margin-top.center(v-if="isValidacao && isCertidao")
          el-checkbox(
            @change="alterarStatusTituloCertidao()"
            border
            :label='true'
            v-model="despachoAtual.validado"
          ) {{despachoAtual.validado ? 'Validada' : 'Marcar como conferida'}}

        div.flex.extra-margin-top
          div
            el-button.btn(
              type="default"
              class="cancelBtn"
              @click="cancelar()"
            )
              | &nbsp Cancelar
          div
            el-button.btn(
              type="default"
              @click="downloadPdf()"
            )
              | Download PDF &nbsp
              i.fa.fa-download
            el-button.btn(
              v-if="isValidacao && !isRevisao"
              type="default"
              @click="editarTituloCertidao"
            )
              | Editar {{titulo}} &nbsp
              i.fa.fa-edit
            el-tooltip.item(
              effect='dark',
              content='Existem certidões pendentes para validação',
              placement="top",
              v-if="isCertidao || isValidacao",
              :disabled="podeFinalizarTitulo ? true : false"
            )
              el-button.btn(
                type="success"
                @click="isValidacao && !isCertidao ? finalizar() : confirmarDados()"
                :disabled="isValidacao && isCertidao && !podeFinalizarTitulo ? true : false"
              )
                | Finalizar &nbsp
                i.fa.fa-check
</template>

<script>
import axios from '@/utils/api'
import FileSaver from 'file-saver'
import AppAnaliseHeader from './components/shared/AppAnaliseHeader'
import acaoProcesso from '@/constants/acaoProcesso'
import AppCadastraTituloCertidao from '@/screens/analise/components/AppCadastraTituloCertidao'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import FileHelper from '@/utils/fileHelper'
import AppDespachos from '@/components/AppDespachos'
import AppRadiosTramitacao from '@/components/AppRadiosTramitacao'
import AppEditorTexto from '@/components/AppEditorTexto'
import AppAnexo from '@/components/AppAnexo'
import AppLabel from '@/components/AppLabel'
import AppPdfSlider from '@/components/AppPDFSlider'
import { mapActions } from 'vuex'
import { stringToArrayBuffer } from '@/utils/utils'

export default {
  props: {
    idProcesso: {
      type: [Number, String]
    },
    idTitulo: {
      type: Number
    },
    tipo: {
      type: String,
      default: acaoProcesso.EMITIR_TITULO
    },
    urlOrigem: {
      type: String,
      default: 'CAIXA_ENTRADA'
    },
    isValidacao: {
      type: Boolean,
      default: true
    },
    tipoDespacho: {
      type: String,
      default: 'TITULO_CERTIDAO'
    }
  },

  mixins: [AppNotificacao],

  components: {
    AppAnaliseHeader,
    AppCadastraTituloCertidao,
    AppDespachos,
    AppRadiosTramitacao,
    AppEditorTexto,
    AppAnexo,
    AppLabel,
    AppPdfSlider
  },

  data () {
    return {
      active: 0,
      arrayBytes: [],
      bytes: null,
      despachoAtual: null,
      totalPdfs: 0,
      despachos: null,
      dadosCadastro: null,
      showTitulo: false,
      isDecisao: false,
      acoesRadio: [],
      radios: [],
      action: 'FINALIZAR',
      titulo: '',
      radio: true,
      podeFinalizarTitulo: true,
      hasClickFinalizar: true,
      back: false
    }
  },

  async mounted () {
    await this.init()
    this.tipoDeTitulo()
  },

  computed: {
    isRevisao () {
      return this.action?.split('.')[0] === 'ENCAMINHAR_REVISAO_PORTARIA'
    },
    isReurb () {
      return this.despachoAtual.processo.tipo.codigo === 'REGULARIZACAO_URBANA'
    },
    isCertidao () {
      return this.despachoAtual.processo.tipo.codigo === 'CERTIDAO_TITULO'
    },
    primeiroDocumento () {
      if (this.idTitulo) {
        return this.despachos.find(despacho => despacho.id === this.idTitulo)
      }
      return this.despachoAtual
    }
  },

  methods: {
    ...mapActions({
      getArrayTituloByDespachoId: 'despacho/getArrayTituloByDespachoId',
      tarefa: 'processo/tarefa',
      getDespachosByProcessoETipo: 'despacho/findByFilter',
      iniciaAnalise: 'processo/iniciaAnalise',
      confirmarDadosCertidoes: 'despacho/confirmarDadosCertidoes',
      validarTituloCertidao: 'despacho/validarTituloCertidao',
      finalizarDespacho: 'despacho/finalizar',
      getArrayTituloByProcessoId: 'despacho/getArrayTituloByProcessoId'
    }),

    cancelar () {
      this.confirmBox(
        `Ao cancelar a ${this.tipoEmissao}, ${this.$messages.CANCELAR_EMISSAO_TITULO_CERTIDAO}`,
        this.$messages.TITULO_WARNING,
        () => {
          if (
            this.despachoAtual.processo.status ===
            'AGUARDANDO_CONFERENCIA_CERTIDAO'
          ) {
            this.$router.push({
              name: 'AGUARDANDO_VALIDACAO_ANALISE'
            })
          } else {
            this.$router.back()
          }
        },
        () => {}
      )
    },

    async init () {
      const certidoes = await this.getArrayTituloByProcessoId(this.idProcesso)

      this.arrayBytes = certidoes.map(certidao => ({
        id: certidao.id,
        bytes: stringToArrayBuffer(certidao.bytes)
      }))

      const response = await this.getDespachosByProcessoETipo({
        tipo: this.tipoDespacho,
        idProcesso: this.idProcesso
      })
      const detalhes = await this.iniciaAnalise({
        idProcesso: this.idProcesso,
        tipoAcao: this.tipo
      })
      this.despachos = response
      this.despachoAtual = this.despachos[0]
      this.dadosCadastro = detalhes.setores
      this.totalPdfs = this.despachos.length
      this.radios = await this.tarefa({ processo: this.idProcesso })
      this.acoesRadio = this.radios.acoes
      this.bytes = this.arrayBytes[0].bytes

      if (this.isCertidao) {
        this.despachos.forEach(despacho => {
          if (!despacho.validado) {
            this.podeFinalizarTitulo = false
          }
        })
      }
    },

    changePdfDownload (documento) {
      this.bytes = documento.bytes
      this.despachoAtual = this.despachos.find(
        despacho => despacho.id === documento.id
      )
    },

    downloadPdf () {
      FileHelper.saveFile(
        this.bytes,
        this.despachoAtual.processo.tipo.codigo === 'CERTIDAO_TITULO'
          ? 'minuta da certidão'
          : 'minuta do título'
      )
    },

    async getDownload (documento) {
      const file = await axios({
        method: 'POST',
        url: `documento/file`,
        data: documento,
        responseType: 'blob'
      })
      FileSaver.saveAs(file, documento.nome)
    },

    changeRadio (value) {
      this.despachoAtual.acao = value.acao
    },

    changeRadioDespacho (value) {
      this.action = value.acao
    },

    downloadDocumentoCadastro (documento) {
      this.getDownload(documento)
    },
    async confirmarDados () {
      const routeName = this.isValidacao
        ? 'AGUARDANDO_VALIDACAO_ANALISE'
        : 'EM_ANALISE'
      try {
        await this.confirmarDadosCertidoes(this.idProcesso)
        this.$router.push({
          name: routeName
        })
        this.showNotificacao(
          this.$messages.TIPO_SUCCESS,
          this.$messages.TITULO_SUCCESS,
          'Processo encaminhado com sucesso'
        )
      } catch (e) {
        this.showNotificacao(
          this.$messages.TIPO_WARNING,
          this.$messages.TITULO_WARNING,
          this.$messages.ERROS_ANALISE
        )
      }
    },

    editarTituloCertidao () {
      this.$router.push({
        name: 'continuar-emissao-titulo',
        params: {
          despachoEdicao: this.despachoAtual,
          idProcesso: this.idProcesso,
          tipo: acaoProcesso.CONFERENCIA_TITULO,
          urlOrigem: `conferencia-certidao/${this.idProcesso}`
        }
      })
    },

    tipoDeTitulo () {
      switch (this.despachoAtual.processo.tipo.codigo) {
        case 'CERTIDAO_TITULO':
          this.tipoEmissao = 'Emissão de certidão título'
          this.titulo = 'certidão título'
          this.mensagem = 'Certidão conferida com sucesso!'
          break
        case 'ONEROSO':
        case 'NAO_ONEROSO':
          this.tipoEmissao = 'Emissão de título'
          this.titulo = 'título'
          this.mensagem = 'Solicitação enviada com sucesso!'
          break
        case 'REGULARIZACAO_URBANA':
          this.tipoEmissao = 'Emissão de título'
          this.titulo = 'título'
          this.mensagem = 'Título conferido com sucesso!'
          break
      }
    },

    alterarStatusTituloCertidao (val) {
      this.validarTituloCertidao(this.despachoAtual.id)
      this.verificaPodeFinalizarTitulo()
    },

    verificaPodeFinalizarTitulo () {
      this.podeFinalizarTitulo = true
      this.despachos.forEach(despacho => {
        if (!despacho.validado) {
          this.podeFinalizarTitulo = false
        }
      })
    },

    async finalizar () {
      if (this.isRevisao) {
        const valido = await this.$refs.validation.validate()
        if (!valido) {
          this.showNotificacao(
            this.$messages.TIPO_WARNING,
            this.$messages.TITULO_WARNING,
            this.$messages.ERROS_ANALISE
          )
          return
        }
        this.despachoAtual.tipo = 'REVISAO'
      }
      if (!this.isReurb && !this.isCertidao) {
        const valido = await this.$refs.validationTitulo.validate()
        if (!valido) {
          this.showNotificacao(
            this.$messages.TIPO_WARNING,
            this.$messages.TITULO_WARNING,
            this.$messages.ERROS_ANALISE
          )
          return
        }
      }
      this.confirmBox(
        this.$messages.CONFIRM_EMISSAO_CONFERENCIA_TITULO,
        this.$messages.TITULO_WARNING,
        () => {
          if (this.hasClickFinalizar) {
            this.hasClickFinalizar = false
            this.finalizarDespacho(this.despachoAtual)
              .then(() => {
                this.showNotificacao(
                  this.$messages.TIPO_SUCCESS,
                  this.$messages.TITULO_SUCCESS,
                  this.mensagem
                )
                this.$router.push({
                  name: 'AGUARDANDO_VALIDACAO_ANALISE'
                })
                this.hasClickFinalizar = true
              })
              .catch(() => {
                this.showNotificacao(
                  this.$messages.TIPO_ERROR,
                  this.$messages.TITULO_ERROR,
                  'Erro ao conferir Título.'
                )
                this.hasClickFinalizar = true
              })
          }
        },
        () => {}
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.flex {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.flex-around {
  width: 100%;
  display: flex;
  justify-content: space-around;
}
.input-text-editor {
  margin-top: 30px;
}

.center {
  display: flex;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/ConfirmarDadosCertidao.vue